import React, { useState, useEffect } from 'react';
import { Crown, User, Menu } from 'lucide-react';
import { useNavigate, Link, useLocation } from 'react-router-dom';
import { shopService } from '../../services/shopService';

const Navbar = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [shopName, setShopName] = useState('DIGISAHYADRI');
  const shopId = new URLSearchParams(location.search).get('shopId') || sessionStorage.getItem('currentShopId');

  useEffect(() => {
    if (shopId) {
      const fetchShop = async () => {
        try {
          const shop = await shopService.getShopById(shopId);
          if (shop) setShopName(shop.shopName);
        } catch (e) {
          console.error(e);
        }
      };
      fetchShop();
    } else {
      setShopName('DIGISAHYADRI');
    }
  }, [shopId, location.pathname]);

  return (
    <nav className="fixed top-0 left-0 right-0 z-50 px-8 py-6 backdrop-blur-md bg-white/50 border-b border-black/[0.03]">
      <div className="max-w-7xl mx-auto flex items-center justify-between">
        <Link to="/" className="flex items-center gap-3 group">
          <div className="w-10 h-10 rounded-full border border-black/[0.05] bg-black flex items-center justify-center transition-all">
            <Crown className="text-[#d4af37]" size={18} />
          </div>
          <span className="text-lg font-serif tracking-[0.1em] text-black uppercase">
            {shopName === 'DIGISAHYADRI' ? (
              <>DIGI<span className="luxury-text">SAHYADRI</span></>
            ) : (
              <span className="luxury-text italic">{shopName}</span>
            )}
          </span>
        </Link>

        <div className="hidden md:flex items-center gap-12">
          <Link to="/scan" className="text-[10px] font-bold tracking-[0.3em] uppercase text-[#999] hover:text-black transition-colors">Scan</Link>
          <button 
            onClick={() => navigate('/login')}
            className="flex items-center gap-2 text-[10px] font-bold tracking-[0.3em] uppercase text-black"
          >
            <User size={14} className="text-[#d4af37]" />
            Account
          </button>
        </div>

        <div className="flex md:hidden items-center gap-4">
          <Menu className="text-black" size={20} />
        </div>

      </div>
    </nav>
  );
};

export default Navbar;
